import { render, staticRenderFns } from "./AuthenticationHeader.vue?vue&type=template&id=92c8df9c&scoped=true&"
import script from "./AuthenticationHeader.vue?vue&type=script&lang=js&"
export * from "./AuthenticationHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationHeader.vue?vue&type=style&index=0&id=92c8df9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c8df9c",
  null
  
)

export default component.exports